<template>
  <div aria-hidden class="absolute top-1 z-[1] -ml-8" :class="arrowClassNames">
    <!-- Arrow border -->
    <svg
      class="absolute left-0 top-[-9px]"
      fill="none"
      height="9"
      viewBox="0 0 17 9"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.157227 8.854L6.82389 1.46604C7.56027 0.649991 8.75418 0.649991 9.49056 1.46604L16.1572 8.854H0.157227Z"
        fill="white"
      />
      <path
        d="M15.0326 8.354H1.28188L7.1951 1.80101C7.73292 1.205 8.58153 1.205 9.11935 1.80101L15.0326 8.354Z"
        stroke-width="1"
      />
    </svg>

    <!-- Arrow filling -->
    <svg
      class="absolute -top-8 left-0"
      fill="none"
      height="9"
      viewBox="0 0 17 9"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.157227 8.354L6.82389 0.966043C7.56027 0.149991 8.75418 0.149991 9.49056 0.966043L16.1572 8.354H0.157227Z"
      />
    </svg>
  </div>
</template>

<script lang="ts" setup>
import { computed, useCssModule } from 'vue'

import { ARROW_AVAILABLE_POSITION } from './Arrow.constants'

const props = withDefaults(
  defineProps<{
    checked?: boolean
    disabled?: boolean
    position?: string | null
  }>(),
  {
    checked: false,
    disabled: false,
    position: ARROW_AVAILABLE_POSITION.LEFT,
  },
)

const style = useCssModule()

const arrowClassNames = computed(() => {
  const styles = [style[`arrow-${props.position}`]]

  if (props.disabled) {
    styles.push(style['arrow-disabled'])
  } else if (props.checked) {
    styles.push(style['arrow-checked'])
  } else {
    styles.push(style['arrow-default'])
  }

  return styles
})
</script>

<style module>
.arrow-left {
  left: calc(100% / 6);
}
.arrow-middle {
  left: 50%;
}
.arrow-right {
  left: calc(100% / 6 * 5);
}

.arrow-default svg:nth-child(1) {
  stroke: #2f3137;
}
.arrow-default svg:nth-child(2) path {
  fill: #ffff;
}

.arrow-disabled svg:nth-child(1) {
  stroke: #c3c5cb;
}
.arrow-disabled svg:nth-child(2) path {
  fill: #0e10160d;
}

.arrow-checked svg:nth-child(1) {
  stroke: #2f3137;
}
.arrow-checked svg:nth-child(2) path {
  /** Our color tokens have transparency, so we wan't override the underlying block using them */
  fill: #f1f1f1;
}
</style>
